import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { AboutServices } from './components/AboutServices';
import { Team } from './components/Team';
import { Projects } from './components/Projects';
import { ProcessTestimonials } from './components/ProcessTestimonials';
import { EditorialContact } from './components/EditorialContact';
import { FloatingUi } from './components/FloatingUi';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-[#F7F4EF] text-[#1A1A1A]" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <AboutServices data-id="element-4" />
        <Team data-id="element-5" />
        <Projects data-id="element-6" />
        <ProcessTestimonials data-id="element-7" />
        <EditorialContact data-id="element-8" />
      </main>
      <FloatingUi data-id="element-9" />
    </div>;
}